import React, {useRef, useState, useEffect, useCallback} from 'react';
import styled from 'styled-components';

import {OzContainer, OzRow, OzCol, OzCard, OzTable, OzProjectTag, OzUserTag, OzButton, OzLoading, OzCopyable, BITTERSWEET} from '@ozwol/webui';

import ProjectsService from './../../services/ProjectsService';
import UsersService from './../../services/UsersService';
import CoworkersService from './../../services/CoworkersService';
import ScriptsService from './../../services/ScriptsService';
import LogsService from './../../services/LogsService';

import {formatError, changeDate, getFormattedDate, getFormattedTime, convertSize} from './../../helpers';

import Filters from './../../components/Filters';
// import LogToggle from './../../components/LogToggle';
import Meta from './../../components/Meta';
import PageHeader from '../../components/PageHeader';
import CardHeaderTitle from '../../components/CardHeaderTitle';
import HealthyWrapper from '../../components/HealthyWrapper';
// import Overlay from './../../components/Overlay';


const TableWrapper = styled.div`
  overflow-x: auto;
  
  & > table{
    width: 100%;
    max-width: 100%;
    overflow-wrap: break-word;
  }
  & > table b{
    white-space: nowrap;
    margin: 0px 5px 0px 15px;
  }
  // & table tr td:nth-child(2),
  // & table tr td:nth-child(3),
  // & table tr td:nth-child(4),
  & > table tr td:nth-child(6) > *{
    // overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  // & > table tr td:nth-child(6){
  //   // white-space: nowrap;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  // }
  // & > table tr td:nth-child(6) * {
  //   // border: 1px solid red;
  //   // white-space: nowrap;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  // }
`;
const NoResult = styled.div`
  text-align: center;
`;
const LogCost = styled.div`
  text-align: center;
`;
const LogExecution = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 10px;
  color: ${props => props.status === "ERROR" ? "#FF4848" : props.status === "WARNING" ? "#FFB100" : "#4AD384"};
  margin: 0 auto;
`;
const Dark = styled.div`;
  font-size: 12px;
`;
const Light = styled.div`
  color: #30303099;
  font-size: 12px;
`;
const Accordion = styled.div`
  display: flex;
  font-size: 12px;
  justify-content: space-between;
`;
const AccordionLeft = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  width: ${props => props.full ? "100%" : "60%"};
`;
const AccordionRight = styled.div`
  color: ${BITTERSWEET};
  flex-grow: 0;
  flex-shrink: 0;
  width: 40%;
`;
const LogRow = styled.div`
  display: flex;
  padding-bottom: 3px;
  padding-left: 20px;
`;
const LogKey = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  width: 150px;
  white-space: nowrap;
  font-weight: 600;
`;
const LogValue = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  white-space: normal; 
  width: calc(100% - 150px);
`;

const CardPhrase = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

const CardPhraseText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #303030;
  position: relative;
  top: 2px;

  display: flex;
  // align-items: baseline;
`;
const CardPhraseSuperNumber = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #303030;
  margin: 0px 5px;
  position: relative;
  top: -2px;
`;
const Filename = styled.div`

`;


const InsiderLogs = ({refScrollerPage}) => {
  let scrollRef = useRef(null);
  const [fetchError, setFetchError] = useState(false);
  const [list, setList] = useState(null);
  const [page, setPage] = useState(1);
  // const [totPages, setTotPages] = useState(1);
  // const totPages = 1;
  const [listUsers, setListUsers] = useState([]);
  const [listAuthors, setListAuthors] = useState([]);
  const [filterSearchAuthors, setFilterSearchAuthors] = useState([]);
  const [listProjects, setListProjects] = useState([]);
  const [filterSearchProjects, setFilterSearchProjects] = useState([]);
  const [filterSearchOwners, setFilterSearchOwners] = useState([]);
  const [filterSearchScripts, setFilterSearchScripts] = useState([]);
  const [listLists, setListLists] = useState([]);
  const [totResults, setTotResults] = useState(0);


  const DEFAULT_FILTERS = {
    "search": "",
    "user_uuid": null,
    "project_uuid": null,
    "rangeDate": changeDate(new Date(), -6, "days", "startOfDay") + "|" + changeDate(new Date(), 0, "days", "endOfDay"),
    "result": null,
    "error_scope": null,
    "consumer_type": null,
    "origin": null,
    "script_uuid": null,
    "creditMin": "",
    "creditMax": "",
    "author_uuid": null,
    "destination_type": null,
    "hideTrivial": true
  };
  const [filters, setFilters] = useState(
    localStorage.getItem("ozwolConsoleFilterInsiderLogs"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1))) ? 
      JSON.parse(localStorage.getItem("ozwolConsoleFilterInsiderLogs"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1))))
    : 
      DEFAULT_FILTERS
    );

  const [filtersSearch, setFiltersSearch] = useState({
    "user_uuid": "",
    "project_uuid": "",
    "script_uuid": ""
  });

  const changeFilters = useCallback((name, value) => {
    setPage(0);
    let tempFilters = {...filters};
    if(name === "rangeDate"){
      let start = value.split('|')[0] !== "null" ? value.split('|')[0] : changeDate(new Date(), -6, "days", "startOfDay");
      let end = value.split('|')[1] !== "null" ? value.split('|')[1] : changeDate(new Date(), 0, "days", "endOfDay");
      value = start+"|"+end;
    }
    tempFilters[name] = value;
    setFilters(tempFilters);
  }, [filters]);

  const searchFilters = useCallback((name, value) => {
    let tempFiltersSearch = {...filtersSearch};
    tempFiltersSearch[name] = value;
    setFiltersSearch(tempFiltersSearch);


    if(value.length > 2 || value.length === 0){
      switch(name){
        case "project_uuid":
          ProjectsService.adminList({
            "search": value.length > 2 ? value : ""
          }).then((response) => {
            setFilterSearchProjects(response);
          });
          break;
        case "user_uuid":
          UsersService.adminList({
            "search": value.length > 2 ? value : ""
          }).then((response) => {
            setFilterSearchOwners(response.result);
          });
          break;
        case "script_uuid":
          ScriptsService.adminList({
            "search": value.length > 2 ? value : ""
          }).then((response) => {
            setFilterSearchScripts(response.result);
          });
          break;
        case "author_uuid":
          UsersService.adminList({
            "search": value.length > 2 ? value : ""
          }).then((response1) => {
            CoworkersService.adminList({
              "search": value.length > 2 ? value : ""
            }).then((response2) => {
              setFilterSearchAuthors(response1.result.concat(response2.result));
            });
          });
          break;
        default:
          break;
      }
    }

  }, [filtersSearch]);

  const getList = useCallback(() => {
    if(scrollRef && scrollRef.current){
      scrollRef.current.scrollTo(0,0);
    }
    LogsService.list(filters.search, {
      user_uuid: filters.user_uuid,
      project_uuid: filters.project_uuid,
      result: filters.result,
      error_scope: filters.error_scope,
      start: filters.rangeDate.split('|')[0],
      end: filters.rangeDate.split('|')[1],
      consumer_type: filters.consumer_type,
      origin: filters.origin,
      script_uuid: filters.script_uuid,
      creditMin: filters.creditMin,
      creditMax: filters.creditMax,
      author_uuid: filters.author_uuid,
      destination_type: filters.destination_type,
      hideTrivial: filters.hideTrivial
    }).then((response) => {
      localStorage.setItem("ozwolConsoleFilterInsiderLogs"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1)), JSON.stringify(filters));
      setList(response.hits);
      setTotResults(response.found);
    }).catch((error) => {
      setList(null);
      setFetchError(formatError(error));
    });

  }, [filters]);

  const loadMore = useCallback(() => {
    LogsService.list(filters.search, {
      user_uuid: filters.user_uuid,
      project_uuid: filters.project_uuid,
      result: filters.result,
      error_scope: filters.error_scope,
      start: filters.rangeDate.split('|')[0],
      end: filters.rangeDate.split('|')[1],
      consumer_type: filters.consumer_type,
      origin: filters.origin,
      script_uuid: filters.script_uuid,
      creditMin: filters.creditMin,
      creditMax: filters.creditMax,
      author_uuid: filters.author_uuid,
      destination_type: filters.destination_type,
      hideTrivial: filters.hideTrivial
    }, page+1).then((response) => {
      let tempList = [...list, ...response.hits];
      setList(tempList);
      setPage(page+1);
    }).catch((error) => {
      // setList(null);
      // setFetchError(formatError(error));
    });

  }, [list, page, filters]);



  useEffect(() => {
    getList();
  }, [getList, filters]);

  useEffect(() => {
    ProjectsService.adminList().then((response) => {
      setFilterSearchProjects(response);
      setListProjects(response);
    });
    UsersService.adminList().then((response1) => {
      setFilterSearchOwners(response1.result);
      setListUsers(response1.result);
      CoworkersService.adminList().then((response2) => {
        setListAuthors(response1.result.concat(response2.result));
        setFilterSearchAuthors(response1.result.concat(response2.result));
      });
    });
      setListAuthors([]);
      setFilterSearchAuthors([]);
    ScriptsService.adminList().then((response) => {
      setFilterSearchScripts(response.result);
    });
    LogsService.listLists().then((response) => {
      setListLists(response.result);
    }).catch((error) => {
      setListLists(null);
      setFetchError(formatError(error));
    });
  }, []);

  
  return (
    <>
      <Meta title={"Logs - Insider"} />
      <OzContainer size="extra">
        <PageHeader
          breadcrumbsIcon="checklist_rtl"
          breadcrumbsText={["Logs"]}
          refScrollerPage={refScrollerPage}
        />

        <OzRow>
          <OzCol>
            <HealthyWrapper error={fetchError} loading={!list}>
              <OzCard
                headerLeft={
                  <CardHeaderTitle title={"Logs"} />
                }
                headerSeparator={true}
                headerRight={
                  <CardPhrase>
                    <CardPhraseText>
                    Total results
                      <CardPhraseSuperNumber>
                        {totResults}
                      </CardPhraseSuperNumber>
                    </CardPhraseText>
                  </CardPhrase>
                }
              >
                <OzRow>
                  <OzCol widthmd="12">
                    <Filters
                      onChange={(...args) => changeFilters(...args)}
                      onSearch={(...args) => searchFilters(...args)}
                      fields={
                        [
                          {
                            "label": "Owner",
                            "name": "user_uuid",
                            "size": 4,
                            "type": "searchableselect",
                            "placeholder": null,
                            "value": filters.user_uuid,
                            "options": [{
                              "name": <i>All</i>,
                              "value": null,
                            }].concat(filterSearchOwners.map((item) => ({
                              "name": <OzUserTag
                                  name={item.givenName + " " + item.familyName}
                                  email={item.email}
                                  direction="horizontal"
                                />,
                              "value": item.uuid,
                            })))
                          },{
                            "label": "Project",
                            "name": "project_uuid",
                            "size": 4,
                            "type": "searchableselect",
                            "placeholder": null,
                            "value": filters.project_uuid,
                            "options": [{
                              "name": <i>All</i>,
                              "value": null,
                            }].concat(filterSearchProjects.map((item) => ({
                              "name": <OzProjectTag
                                  name={item.name}
                                  uuid={item.uuid}
                                  color={item.color}
                                  direction="horizontal"
                                />,
                              "value": item.uuid,
                            })))
                          },{
                            "label": "Search",
                            "name": "search",
                            "size": 4,
                            "type": "text",
                            "placeholder": null,
                            "value": filters.search
                          },{
                            "label": "Date",
                            "name": "rangeDate",
                            "size": 1,
                            "type": "rangedate",
                            "placeholder": null,
                            "value": filters.rangeDate
                          },{
                            "label": "Result",
                            "name": "result",
                            "size": 2,
                            "type": "select",
                            "placeholder": null,
                            "value": filters.result,
                            "options": [
                              {
                                "name": "All logs",
                                "value": null
                              }
                            ].concat(listLists && listLists["ScriptResult"] ? listLists["ScriptResult"].map((item) => ({
                              "name": item,
                              "value": item,
                            })): [])
                          },{
                            "label": "Error Scope",
                            "name": "error_scope",
                            "size": 2,
                            "type": "select",
                            "placeholder": null,
                            "value": filters.error_scope,
                            "options": [
                              {
                                "name": "All logs",
                                "value": null
                              }
                            ].concat(listLists && listLists["ErrorScope"] ? listLists["ErrorScope"].map((item) => ({
                              "name": item,
                              "value": item,
                            })): [])
                          },{
                            "label": "Consumer type",
                            "name": "consumer_type",
                            "size": 2,
                            "type": "select",
                            "placeholder": null,
                            "value": filters.consumer_type,
                            "options": [
                              {
                                "name": "All logs",
                                "value": null
                              }
                            ].concat(listLists && listLists["ConsumerType"] ? listLists["ConsumerType"].map((item) => ({
                              "name": item,
                              "value": item,
                            })): [])
                          },{
                            "label": "Script",
                            "name": "script_uuid",
                            "size": 3,
                            "type": "searchableselect",
                            "placeholder": null,
                            "value": filters.script_uuid,
                            "options": [{
                              "name": <i>All</i>,
                              "value": null,
                            }].concat(filterSearchScripts.map((item) => ({
                              "name": item.name,
                              "value": item.uuid
                            })))
                          },{
                            "label": "Origin",
                            "name": "origin",
                            "size": 2,
                            "type": "select",
                            "placeholder": null,
                            "value": filters.origin,
                            "options": [
                              {
                                "name": "All logs",
                                "value": null
                              }
                            ].concat(listLists && listLists["ScriptOrigin"] ? listLists["ScriptOrigin"].map((item) => ({
                              "name": item,
                              "value": item,
                            })): [])
                          },{
                            "label": "Dest. type",
                            "name": "destination_type",
                            "size": 2,
                            "type": "select",
                            "placeholder": null,
                            "value": filters.destination_type,
                            "options": [
                              {
                                "name": "All logs",
                                "value": null
                              }
                            ].concat(listLists && listLists["DestinationType"] ? listLists["DestinationType"].map((item) => ({
                              "name": item,
                              "value": item
                            })): [])
                          },{
                            "label": "Credit min",
                            "name": "creditMin",
                            "size": 1,
                            "type": "text",
                            "placeholder": null,
                            "value": filters.creditMin
                          },{
                            "label": "Credit max",
                            "name": "creditMax",
                            "size": 1,
                            "type": "text",
                            "placeholder": null,
                            "value": filters.creditMax
                          },{
                            "label": "Author",
                            "name": "author_uuid",
                            "size": 2,
                            "type": "searchableselect",
                            "placeholder": null,
                            "value": filters.author_uuid,
                            "options": [{
                              "name": <i>All</i>,
                              "value": null,
                            }].concat(filterSearchAuthors.map((item) => ({
                              "name": item.givenName + " " + item.familyName,
                              "value": item.uuid,
                            })))
                          },{
                            "label": "Trivial",
                            "name": "hideTrivial",
                            "size": 2,
                            "type": "select",
                            "placeholder": null,
                            "value": filters.hideTrivial,
                            "options": [{
                              "name": <i>Hide Trivial</i>,
                              "value": true,
                            },{
                              "name": <i>Show Trivial</i>,
                              "value": false,
                            }]
                          },{
                            "size": 2,
                            "type": "refresh",
                            "callback": () => {
                              getList();
                            }
                          },{
                            "size": 2,
                            "type": "clear",
                            "callback": () => {
                              setFilters(DEFAULT_FILTERS);
                              // localStorage.removeItem("ozwolConsoleFilterInsiderLogs"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1)))
                            }
                          }
                        ]
                      }
                    />
                    <hr/>
                    {list ?
                      list.length > 0 ?
                        <>
                          <TableWrapper>
                              <OzTable
                                columns={[
                                  "Project",
                                  "Company",
                                  "Date",
                                  "Time",
                                  "Author",
                                  "File name",
                                  "Activity",
                                  "Size",
                                  <center>Cost</center>,
                                  <center>Exec</center>
                                ]}
                                values={
                                  list.map(item => ({
                                    style: {
                                      color: item.result === "ERROR" ? "#FF4848" : null
                                    },
                                    id: item.document.id,
                                    accordion: <Accordion>
                                      <AccordionLeft full={item.document.result !== "ERROR" && item.document.result !== "WARNING"}>
                                        
                                          {item.document.assets_processed ? 
                                            <LogRow>
                                              <LogKey>Assets processed</LogKey>
                                              <LogValue>{item.document.assets_processed}</LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.author_uuid ? 
                                            <>
                                              <LogRow>
                                                <LogKey>Author</LogKey>
                                                <LogValue>
                                                  {listAuthors.filter(val => val.uuid === item.document.author_uuid).length > 0 ?
                                                    listAuthors.filter(val => val.uuid === item.document.author_uuid).map(author =>
                                                      author.givenName + " " + author.familyName
                                                    )
                                                  : "-"}
                                                </LogValue>
                                              </LogRow>
                                              <LogRow>
                                                <LogKey>Author ID</LogKey>
                                                <LogValue>{item.document.author_uuid}</LogValue>
                                              </LogRow>
                                            </>
                                          : null}
                                          {item.document.user_uuid ? 
                                            <LogRow>
                                              <LogKey>Company</LogKey>
                                              <LogValue> 
                                                {listUsers.filter(val => val.uuid === item.document.user_uuid).length > 0 ?
                                                  listUsers.filter(val => val.uuid === item.document.user_uuid).map(user =>
                                                    user.company
                                                  )
                                                : "-"}
                                              </LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.consumer_type ? 
                                            <LogRow>
                                              <LogKey>Consumer type</LogKey>
                                              <LogValue>{item.document.consumer_type}</LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.credit_price ? 
                                            <LogRow>
                                              <LogKey>Credit price</LogKey>
                                              <LogValue>{item.document.credit_price}</LogValue>
                                            </LogRow>
                                          : null}
                                          <LogRow>
                                            <LogKey>Date</LogKey>
                                            <LogValue>{getFormattedDate(item.document.create_datetime)}</LogValue>
                                          </LogRow>
                                          {item.document.destination_file_key ? 
                                            <LogRow>
                                              <LogKey>Destination file key</LogKey>
                                              <LogValue>
                                                <OzCopyable>{item.document.destination_file_key}</OzCopyable>
                                              </LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.destination_file_key ? 
                                            <LogRow>
                                              <LogKey>Destination file name</LogKey>
                                              <LogValue>
                                                <OzCopyable>{item.document.destination_file_key.substring(item.document.destination_file_key.lastIndexOf('/')+1)}</OzCopyable>
                                              </LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.destination_file_size ? 
                                            <LogRow>
                                              <LogKey>Destination file size</LogKey>
                                              <LogValue>{convertSize(item.document.destination_file_size)}</LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.destination_type ? 
                                            <LogRow>
                                              <LogKey>Destination type</LogKey>
                                              <LogValue>{item.document.destination_type}</LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.job_uuid ? 
                                            <LogRow>
                                              <LogKey>Job ID</LogKey>
                                              <LogValue>
                                                <OzCopyable>{item.document.job_uuid}</OzCopyable>
                                              </LogValue>
                                            </LogRow>
                                          : null}
                                          <LogRow>
                                            <LogKey>Log ID</LogKey>
                                            <LogValue>
                                              <OzCopyable>{item.document.id}</OzCopyable>
                                            </LogValue>
                                          </LogRow>
                                          {item.document.origin ? 
                                            <LogRow>
                                              <LogKey>Origin</LogKey>
                                              <LogValue>{item.document.origin}</LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.processing_time_ms ? 
                                            <LogRow>
                                              <LogKey>Process time (ms)</LogKey>
                                              <LogValue>{item.document.processing_time_ms}</LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.project_uuid ? 
                                            <LogRow>
                                              <LogKey>Project</LogKey>
                                              <LogValue> 
                                                {listProjects.filter(val => val.uuid === item.document.project_uuid).length > 0 ?
                                                  listProjects.filter(val => val.uuid === item.document.project_uuid).map(project =>
                                                    project.name
                                                  )
                                                : "-"}
                                              </LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.project_uuid ? 
                                            <LogRow>
                                              <LogKey>Project ID</LogKey>
                                              <LogValue> 
                                                <OzCopyable>{item.document.project_uuid}</OzCopyable>
                                              </LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.response_size ? 
                                            <LogRow>
                                              <LogKey>Response size</LogKey>
                                              <LogValue>{convertSize(item.document.response_size)}</LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.script_name ? 
                                            <LogRow>
                                              <LogKey>Script</LogKey>
                                              <LogValue>{item.document.script_name}</LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.script_uuid ? 
                                            <LogRow>
                                              <LogKey>Script ID</LogKey>
                                              <LogValue>
                                                <OzCopyable>{item.document.script_uuid}</OzCopyable>
                                              </LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.source_file_key ? 
                                            <LogRow>
                                              <LogKey>Source file key</LogKey>
                                              <LogValue>
                                                <OzCopyable>{item.document.source_file_key}</OzCopyable>
                                              </LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.source_file_key ? 
                                            <LogRow>
                                              <LogKey>Source file name</LogKey>
                                              <LogValue>
                                                <OzCopyable>{item.document.source_file_key.substring(item.document.source_file_key.lastIndexOf('/')+1)}</OzCopyable>
                                              </LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.source_file_size ? 
                                            <LogRow>
                                              <LogKey>Source file size</LogKey>
                                              <LogValue>{convertSize(item.document.source_file_size)}</LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.storage_bytes ? 
                                            <LogRow>
                                              <LogKey>Storage bytes</LogKey>
                                              <LogValue>{convertSize(item.document.storage_bytes)}</LogValue>
                                            </LogRow>
                                          : null}
                                          <LogRow>
                                            <LogKey>Time</LogKey>
                                            <LogValue>{getFormattedTime(item.document.create_datetime)}</LogValue>
                                          </LogRow>
                                          {item.document.transfer_bytes ? 
                                            <LogRow>
                                              <LogKey>Transfer bytes</LogKey>
                                              <LogValue>{convertSize(item.document.transfer_bytes)}</LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.user_uuid ? 
                                            <LogRow>
                                              <LogKey>User</LogKey>
                                              <LogValue> 
                                                {listUsers.filter(val => val.uuid === item.document.user_uuid).length > 0 ?
                                                  listUsers.filter(val => val.uuid === item.document.user_uuid).map(user =>
                                                    user.givenName + " " + user.familyName
                                                  )
                                                : "-"}
                                            </LogValue>
                                          </LogRow>
                                        : null}
                                        {item.document.user_uuid ? 
                                          <LogRow>
                                            <LogKey>User ID</LogKey>
                                            <LogValue>
                                              <OzCopyable>{item.document.user_uuid}</OzCopyable>
                                            </LogValue>
                                          </LogRow>
                                        : null}
                                      </AccordionLeft>
                                      {item.document.result === "ERROR" || item.document.result === "WARNING" ?
                                        <AccordionRight>
                                        
                                          {item.document.error_code ? 
                                            <LogRow>
                                              <LogKey>Error</LogKey>
                                              <LogValue>{item.document.error_code}</LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.error_description ? 
                                            <LogRow>
                                              <LogKey>Description</LogKey>
                                              <LogValue>{item.document.error_description}</LogValue>
                                            </LogRow>
                                          : null}
                                          {item.document.error_scope ? 
                                            <LogRow>
                                              <LogKey>Type</LogKey>
                                              <LogValue>{item.document.error_scope}</LogValue>
                                            </LogRow>
                                          : null}
                                        </AccordionRight>
                                       : null}
                                    </Accordion>,
                                    values: [
                                      listProjects.filter(val => val.uuid === item.document.project_uuid).length > 0 ?
                                        listProjects.filter(val => val.uuid === item.document.project_uuid).map(project =>
                                          <OzProjectTag
                                            direction="horizontal"
                                            key={project.uuid}
                                            name={project.name}
                                            uuid={project.uuid}
                                            color={project.color}
                                            display={"inline"}
                                          />
                                        )
                                      : "-",
                                      listUsers.filter(val => val.uuid === item.document.user_uuid).length > 0 ?
                                        listUsers.filter(val => val.uuid === item.document.user_uuid).map(user =>
                                          <Light key={user.uuid}>{user.company}</Light>
                                        )
                                      : "-",
                                      <Dark>
                                        {getFormattedDate(item.document.create_datetime)}
                                      </Dark>,
                                      <Light>
                                        {getFormattedTime(item.document.create_datetime)}
                                      </Light>,
                                      <Dark>
                                        {listAuthors.filter(val => val.uuid === item.document.author_uuid).length > 0 ?
                                          listAuthors.filter(val => val.uuid === item.document.author_uuid).map(author =>
                                            author.givenName + " " + author.familyName
                                          )
                                        : "-"}
                                      </Dark>,
                                      <Dark>
                                        {item.document.source_file_key ? 
                                          <Filename title={item.document.source_file_key.substring(item.document.source_file_key.lastIndexOf('/')+1)}>
                                            <div onClick={(e) => {e.preventDefault(); e.stopPropagation()}}>
                                              <OzCopyable text={item.document.source_file_key.substring(item.document.source_file_key.lastIndexOf('/')+1)}>
                                                {((item.document.source_file_key.substring(item.document.source_file_key.lastIndexOf('/')+1))
                                                .length > 20 ? 
                                                  item.document.source_file_key.substring(item.document.source_file_key.lastIndexOf('/')+1)
                                                  .slice(0, 17)
                                                  +"..."
                                                :
                                                  item.document.source_file_key.substring(item.document.source_file_key.lastIndexOf('/')+1)
                                                )}
                                              </OzCopyable>
                                            </div>
                                          </Filename>
                                        : "-"}
                                      </Dark>,
                                      <Dark>
                                        {item.document.consumer_type === "SCRIPT" ? 
                                          item.document.script_name
                                        :
                                          item.document.consumer_type
                                        }
                                      </Dark>,
                                      item.document.consumer_type === "STORAGE" ?
                                        convertSize(item.document.storage_in_use)
                                      : item.document.consumer_type === "TRANSFER" ?
                                        convertSize(item.document.transfer_consumed)
                                      :
                                        convertSize(item.document.destination_file_size),
                                      <LogCost>{item.document.credit_price}</LogCost>,
                                      <LogExecution status={item.document.result}>
                                        <span className="material-symbols-outlined">{
                                          item.document.result === "SUCCESS" ? 
                                            "done"
                                          : item.document.result === "WARNING" ? 
                                            "warning"
                                          : item.document.result === "ERROR" ? 
                                            "close"
                                          : item.document.result === "ONGOING" ? 
                                            "hourglass_empty"
                                          : null
                                        }</span>
                                      </LogExecution>
                                    ]
                                  }))
                                }
                              />
                            </TableWrapper>
                            {totResults > list.length ? 
                              <>
                                <br/><br/>
                                <center>
                                  <OzButton variant="push-black" onClick={() => loadMore()}>The previous 100...</OzButton>
                                </center>
                              </>
                            : null}
  
                        </>
                      : <NoResult />
                    : <OzLoading />}
                  </OzCol>
                </OzRow>
              </OzCard>
            </HealthyWrapper>
          </OzCol>
        </OzRow>

      </OzContainer>
    </>
  )
}

export default InsiderLogs;
